import { API_URL } from "../../../constants";

export const API_MODEL_TYPE_SHOP = 'shop';
export const SHOPS_API_PATH = `${API_URL}/shops`;
export const PAGINATION_PER_PAGE = 20;

